import React from "react";
import { useNavigate } from "react-router-dom";
import { FaUserGear, FaUserTie, FaUsersBetweenLines, FaUsersGear } from "react-icons/fa6";
import Folder from "../atoms/Folder";
import Heading from "../atoms/Heading";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const UsuariosTemplate = () => {
    const navigate = useNavigate();

    const data = [
        { name:"Adminstradores generales", rute:"GeneralAdmin", icon:FaUserTie },
        { name:"Administrativos", rute:"Administrative", icon:FaUserGear },
        { name:"Residentes", rute:"Resident", icon:FaUsersBetweenLines },
        { name:"Mantenimiento", rute:"Staff", icon:FaUsersGear },
    ];

    return(
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/inicio" },
                            { label: "Usuarios", to: null },
                        ]}
                    />
                }
            />
            <div className="w-full gap-4 grid grid-cols-1 md:grid-cols-2">
                {data.map((r, index) => (
                    <Folder
                        key={index}
                        onClick={()=> navigate(r.rute) }
                        children={
                            <div className="h-full flex flex-col justify-around items-center">
                                <Heading text={r.name} color="white"/>
                                {React.createElement(r.icon, { size: 90, color: "white" })}
                            </div>
                        }
                    />
                ))}
            </div>
        </div>
    );
};

export default UsuariosTemplate;